import { Common, color } from '@stockbit/ui';
import styled from 'styled-components';

const { Input } = Common;

export const LoginInputNumber = styled(Input)`
  width: 48px !important;
  height: 56px;
  font-size: 24px;
  border-radius: 8px;
  text-align: center;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }

  &:focus {
    border: 1px solid ${color.primary};
  }
`;
